import { TooltipFormatterContextObject } from "highcharts";
import numeral from "numeral";

export const DEFAULT_CHART_CONFIG = Object.freeze({
  accessibility: {
    point: {
      valueSuffix: "%",
    },
  },
  chart: {
    type: "pie",
  },
  credits: {
    enabled: false,
  },
  legend: {
    enabled: true,
  },
  title: null,
  tooltip: {
    formatter(this: TooltipFormatterContextObject): string {
      return `${this.key}<br/><small>${numeral(this.y).format("0,0")}</small>`;
    },
    headerFormat: "<small>{point.key}</small><br/>",
    useHtml: true,
  },
});
